import { ValidationMethod, ValidationType } from 'entities/user/model/types';
import { useValidationUpdateMutation, useValidationConfirmMutation, useLazyValidationResendQuery } from 'entities/validation/api';

export const useLoginActions = () => {
  const [updateValidation] = useValidationUpdateMutation();

  const enableLoginNo = () =>
    updateValidation({
      validationUpdateModel: {
        validationMethod: ValidationMethod.No,
        validationType: ValidationType.Login,
      },
    }).unwrap().catch(error => {throw error.data});

  const enableLoginTwoFactor = () =>
    updateValidation({
      validationUpdateModel: {
        validationMethod: ValidationMethod.TwoFA,
        validationType: ValidationType.Login,
      },
    }).unwrap().catch(error => {throw error.data});

  return {
    enableNo: enableLoginNo,
    enableTwoFactor: enableLoginTwoFactor,
  };
};

export const useConfirmationActions = () => {
  const [updateValidation] = useValidationUpdateMutation();

  const enableConfirmationSms = () =>
    updateValidation({
      validationUpdateModel: {
        validationMethod: ValidationMethod.SMS,
        validationType: ValidationType.Confirmation,
      },
    }).unwrap().catch(error => {throw error.data});

  const enableConfirmationTwoFactor = () =>
    updateValidation({
      validationUpdateModel: {
        validationMethod: ValidationMethod.TwoFA,
        validationType: ValidationType.Confirmation,
      },
    }).unwrap().catch(error => {throw error.data});

  return {
    enableSms: enableConfirmationSms,
    enableTwoFactor: enableConfirmationTwoFactor,
  };
};

export const useUpdateActions = () => {
  const [confirmUpdate] = useValidationConfirmMutation();
  const [resendUpdate] = useLazyValidationResendQuery();

  const confirmUpdateAction = (id: string | number, params: { smsCode?: string; twoFactorCode?: string }) =>
    confirmUpdate({ id, ...params });

  const resendUpdateAction = (id: string | number) => resendUpdate({ id });

  return {
    confirm: confirmUpdateAction,
    resend: resendUpdateAction,
  };
}; 